// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BACK_TO_LIST_OF_GROUPS = "Sp\u00e4\u0165 na zoznam skup\u00edn";
export const GROUP_DESCRIPTION_AND_RULES = "Popis a pravidl\u00e1";
export const GROUP_FEED_SEARCH_RESULT_query_count = ["%(count)s pr\u00edspevok pre \"%(query)s\" v skupine.", "%(count)s pr\u00edspevky pre \"%(query)s\" v skupine.", "%(count)s pr\u00edspevkov pre \"%(query)s\" v skupine."];
export const GROUP_INFO_SHOW_WHOLE_DESCRIPTION = "Zobraz cel\u00fd popis a pravidl\u00e1";
export const GROUP_MODERATORS_SHORT = "Moder\u00e1tori";
export const GROUPS_SEARCH_PLACEHOLDER = "H\u013eadaj v skupine...";
export const NEW_FEATURE_TAG = "Novinka";
export const ORDER_BY = "Zora\u010f pod\u013ea";
export const RECENT_COMMENTS = "Najnov\u0161ie koment\u00e1re";
export const RECENT_POSTS = "Najnov\u0161ie pr\u00edspevky";
